




























































































































































import ExercisesFormWithLabel from '@/components/exercises/forms/ExercisesFormWithLabel.vue'
import ExercisesFormInput from '@/components/exercises/forms/ExercisesFormInput.vue'
import ExercisesFormGroupComments from '@/components/exercises/forms/ExercisesFormGroupComments.vue'
import ExercisesFormGroupFeedback from '@/components/exercises/forms/ExercisesFormGroupFeedback.vue'
import { withDefault, withUnit } from '@/components/exercises/measure/filters'

export default {
  components: {
    ExercisesFormWithLabel,
    ExercisesFormInput,
    ExercisesFormGroupComments,
    ExercisesFormGroupFeedback,
  },
  filters: {
    withDefault,
    withUnit,
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    cardioExercise: {
      type: Object,
      default: null,
      validator: obj =>
        obj === null ||
        [
          'exerciseName',
          'bloodOxygenPerc',
          'heartRateBpm',
          'workload',
          'timeMin',
          'borgScale',
          'o2Ipm',
          'feedbackRating',
          'feedbackMoreWorkLoad',
          'comments',
        ].every(key => key in obj),
    },
    activeIndex: {
      type: Number,
      required: true,
    },
  },
}
